import { CLOSE_UNLOCK_FEATURE_MODAL } from "app/action_types/unlock_modal_action_types";

export function closeUnlockModal() {
    return {
        type: CLOSE_UNLOCK_FEATURE_MODAL,
    };
}
